import { useDispatch, useSelector } from "react-redux";
import { AddButton, HeadersModal, ModalOverlay, TextArea, Field } from "../../styles/common";
import { ComponentUpdate } from "../../store/slices/component";
import { useEffect, useState } from "react";
import { AddProductHome, GetBanners, GetBrands, GetCategories, GetProductByCategoryID, GetSubCategories, GetSubSubCategoriesByCategoryId } from "../../common/CommonApi";
import styled from "styled-components";
import Swal from "sweetalert2";
import _ from "lodash";

const ModalContent = styled.div`
  width: 95%;
  max-width: 900px;
  height: 70vh;
  background: #fff;
  border-radius: 14px;
  padding: 20px;
  overflow-y: auto;
  position: relative;
  margin-top: 0;
  @media (max-width: 768px) {
    width: calc(100% - 16px);
    height: calc(100dvh - 16px);
    padding: 16px;
    border-radius: 12px;
  }
`;


const screens = [
  { value: "category_page", label: "Category Page" },
  { value: "category_page", label: "Category Page" },
  { value: "category_page", label: "Category Page" },
  { value: "category_page", label: "Category Page" },
  { value: "home_page", label: "Home Page" },
  { value: "bag_page", label: "Bag Page" },
  { value: "profile_page", label: "Profile Page" },
  { value: "login_view", label: "Login View" },
  { value: "otp_view", label: "OTP View" },
  { value: "product_by_subcategory", label: "Products By Subcategory" },
  { value: "product_by_banner", label: "Products By Banner" },
  { value: "product_by_brand", label: "Products By Brand" },
  { value: "product_by_colour", label: "Products By Colour" },
  { value: "product_detail", label: "Product Detail" },
  { value: "product_by_category", label: "Products By Category" },
  { value: "checkout_view", label: "Checkout View" },
  { value: "product_by_subcategory_by_subcategory", label: "Products by Subcategory → Subcategory" },
  { value: "splash_page", label: "Splash Page" },
  { value: "order_tracking_page", label: "Order Tracking Page" },
  { value: "address_list_page", label: "Address List Page" },
  { value: "add_address_page", label: "Add Address Page" },
  { value: "myWishlist_page", label: "My Wishlist Page" },
  { value: "myOrders_page", label: "My Orders Page" },
];



export const AddHomeSection = ({ onSaved, closeModel }) => {
  const dispatch = useDispatch();
  const [subCategories, setSubCategories] = useState([]);
  const component = useSelector(state => state.component)
  const [search, setSearch] = useState("");
  const userProfile = useSelector((state) => state.auth);
  const [form, setForm] = useState({
    title: "",
    description: "",
    status: false,
    type: "sub_category",
    component: [],
    layout_type: "horizontal",
    image_type: "square",
    screen: "home_page",
    sort_order: 1,
    category_id: component.categoryId,
  });

  useEffect(() => {
    fetchCategory();
  }, []);

  const fetchCategory = async () => {
    let resp = await GetSubCategories(component.categoryId);
    setSubCategories(resp.data.data);
  };

  const handleSubmit = async () => {
    const ids = form.component.map(item => item.id);
    form.component = ids
    if (ids.length > 0 && !_.isEmpty(form.title) && !_.isEmpty(form.description) && !_.isEmpty(form.type) && !_.isEmpty(form.layout_type) && !_.isEmpty(form.image_type) && !_.isEmpty(form.screen) && !_.isEmpty(component.categoryId)) {
      await AddProductHome(form)
      onSaved()
      closeModel(false)
    } else {
      Swal.fire('One field missing')
    }
  };

  const toggleCategory = (cat) => {
    console.log("--->cat",cat)
    let updated = [...form.component];
    const isSelected = updated.some((c) => c.id === cat._id);

    if (isSelected) {
      updated = updated.filter((c) => c.id !== cat._id);
    } else {
      updated.push({ id: cat._id });
    }
    setForm({ ...form, component: updated });
  };


  useEffect(() => {
    if (form.type == 'sub_category') {
      fetchCategory()
    }
    if (form.type == 'sub_sub_category') {
      fetchSubSubCategory()
    }
    if (form.type == 'banner') {
      fetchBanner()
    }
    if (form.type == 'brands') {
      fetchBrands()
    }
    if (form.type == 'product') {
      fetchProducts()
    }
  }, [form])

  async function fetchSubSubCategory() {
    let subsubCategory = await GetSubSubCategoriesByCategoryId(component.categoryId)
    setSubCategories(subsubCategory.data.data)
  }

  async function fetchBanner() {
    let banner = await GetBanners()
    console.log(("--->brands",banner))
    setSubCategories(banner.data.data)
  }

  async function fetchBrands() {
    let brands = await GetBrands(userProfile?._id)
    setSubCategories(brands.data.data)
  }
  async function fetchProducts() {
    let brands = await GetProductByCategoryID(component.categoryId)
    setSubCategories(brands.data.data)
  }
  const filteredProducts =
    form.type === "product"
      ? subCategories.filter((p) =>
        p.name?.toLowerCase().includes(search.toLowerCase())
      )
      : [];

  const filteredItems =
    form.type === "product" || form.type === "brands"
      ? subCategories.filter((item) => {
        const name =
          form.type === "brands"
            ? item.brandName
            : item.name;

        return name
          ?.toLowerCase()
          .includes(search.toLowerCase());
      })
      : subCategories;
  // console.log("form",form)
  return (
    <ModalOverlay>
      <ModalContent>
        <HeadersModal >
          <h2>Add Section</h2>
          <img
            onClick={() => closeModel(false)}
            style={{ width: "18px", cursor: "pointer" }}
            src="/assets/close.png"
          />
        </HeadersModal>

        {/* TITLE */}
        <label>Title *</label>
        <Input
          placeholder="Title *"
          required
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
        />

        {/* DESCRIPTION */}
        <label>Description</label>
        <TextArea
          placeholder="Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />

        {/* STATUS */}
        <div style={{ display: "flex", gap: "15px", width: "100%" }}>

          <div style={{ flex: 1 }}>
            <label>Status</label>
            <Select
              value={form.status}
              onChange={(e) => setForm({ ...form, status: e.target.value })}
            >
              <option value="true">Active</option>
              <option value="false">Deactive</option>
            </Select>
          </div>

          <div style={{ flex: 1 }}>
            <label>Type</label>
            <Select
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value, component: [] })}
            >
              <option value="sub_category">Sub Category</option>
              <option value="sub_sub_category">Sub Sub Category</option>
              <option value="banner">Banner</option>
              <option value="product">Product</option>
              <option value="brands">Brands</option>
            </Select>

          </div>

        </div>
      {form.type === "product" || form.type === "brands" ? (

  /* ================= PRODUCT / BRAND ================= */

  <>
    <label>
      {form.type === "product"
        ? "Select Products"
        : "Select Brands"}
    </label>

    <Input
      placeholder={`🔍 Search ${
        form.type === "product" ? "product" : "brand"
      }...`}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />

    <SelectionContainer>
      {filteredItems.map((item) => {
        const selected = form.component.some(
          (c) => c.id === item._id
        );

        return (
          <SelectionCard
            key={item._id}
            selected={selected}
            onClick={() => toggleCategory(item)}
          >
            <img
              src={
                form.type === "product"
                  ? item?.variants?.[0]?.varientImages?.[0]
                  : item.brandImage
              }
              alt="item"
            />

            <div>
              <h4>
                {form.type === "brands"
                  ? item.brandName
                  : item.name}
              </h4>

              {form.type === "product" && (
                <p>₹ {item?.variants?.[0]?.disCountedprice}</p>
              )}
            </div>

            {selected && <CheckMark>✓</CheckMark>}
          </SelectionCard>
        );
      })}
    </SelectionContainer>
  </>

) : form.type === "banner" ? (

  /* ================= BANNER ================= */

  <>
    <label>Select Banners</label>

    <BannerGrid>
      {subCategories.map((banner) => {
        const selected = form.component.some(
          (c) => c.id === banner._id
        );

        return (
          <BannerCard
            key={banner._id}
            selected={selected}
            onClick={() => toggleCategory(banner)}
          >
            <img
              src={banner.bannerImage}
              alt={banner.bannerTitle}
            />

            <div className="banner-title">
              {banner.bannerTitle}
            </div>

            {selected && <CheckMark>✓</CheckMark>}
          </BannerCard>
        );
      })}
    </BannerGrid>
  </>

) : (

  /* ================= CATEGORY / SUBCATEGORY ================= */

  <>
    <label>
      {form.type === "sub_category"
        ? "Select Sub Categories"
        : "Select Sub Sub Categories"}
    </label>

    <CategoryGrid>
      {subCategories.map((cat) => {
        const selected = form.component.some(
          (c) => c.id === cat._id
        );

        return (
          <CategoryCard
            key={cat._id}
            selected={selected}
            onClick={() => toggleCategory(cat)}
          >
            <img
              src={cat.subcategoryImage}
              alt={cat.subcategoryName}
            />

            <h4>{cat.subcategoryName}</h4>

            {selected && <CheckMark>✓</CheckMark>}
          </CategoryCard>
        );
      })}
    </CategoryGrid>
  </>
)}
        <div style={{ display: "flex", gap: "15px", width: "100%" }}>

          <div style={{ flex: 1 }}>
            <label>Layout Type</label>
            <Select
              value={form.layout_type}
              onChange={(e) => setForm({ ...form, layout_type: e.target.value })}
            >
              <option value="horizontal">Horizontal</option>
              <option value="vertical">Vertical</option>
            </Select>
          </div>

          <div style={{ flex: 1 }}>
            <label>Screen</label>
            <Select
              value={form.screen}
              onChange={(e) => setForm({ ...form, screen: e.target.value })}
            >
              {screens.map((s) => (
                <option key={s.value} value={s.value}>{s.label}</option>
              ))}
            </Select>
          </div>

        </div>
        <div style={{ display: "flex", gap: "15px", width: "100%" }}>

          <div style={{ flex: 1 }}>
            <label>Sorting Order</label>
            <Input
              placeholder="Sorting Order"
              type="number"
              value={form.sort_order}
              onChange={(e) => setForm({ ...form, sort_order: e.target.value })}
            />
          </div>

          <div style={{ flex: 1 }}>
            <label>Image Type</label>
            <Select
              value={form.image_type}
              onChange={(e) => setForm({ ...form, image_type: e.target.value })}
            >
              <option value="circle">Circle</option>
              <option value="square">Square</option>
              <option value="horizontal_rectangle">Horizontal Rectangle</option>
              <option value="vertical_rectangle">Vertical Rectangle</option>
              <option value="transparant">Transparant</option>
            </Select>
          </div>

        </div>


        {/* SORT ORDER */}


        {/* IMAGE TYPE */}


        <AddButton onClick={handleSubmit}>Save</AddButton>
      </ModalContent>

    </ModalOverlay>
  );
};

const SelectionContainer = styled.div`
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 15px;
  background: #fafafa;
`;

const SelectionCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  margin-bottom: 8px;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  background: ${({ selected }) =>
    selected ? "#000" : "#fff"};
  color: ${({ selected }) =>
    selected ? "#fff" : "#000"};
  border: 1px solid ${({ selected }) =>
    selected ? "#000" : "#eee"};
  transition: 0.2s;

  img {
    width: 45px;
    height: 45px;
    object-fit: cover;
    border-radius: 6px;
  }

  h4 {
    margin: 0;
    font-size: 14px;
  }

  p {
    margin: 0;
    font-size: 12px;
    opacity: 0.7;
  }

  &:hover {
    transform: scale(1.01);
  }
`;



/* STYLES */
const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #bbb;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 16px;
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #bbb;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 16px;
`;

const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  cursor: pointer;
`;

const Button = styled.button`
  background: #000;
  color: #fff;
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 12px;
  cursor: pointer;

  &:hover {
    background: #333;
  }
`;

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 6px;
  margin: 2px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid ${({ selected }) => (selected ? "black" : "#bbb")};
  background: ${({ selected }) => (selected ? "black" : "white")};
  color: ${({ selected }) => (selected ? "white" : "black")};
  transition: 0.2s;

  &:hover {
    background: ${({ selected }) => (selected ? "#333" : "#f4f4f4")};
  }
`;

const Row = styled.div`
  display: grid; grid-template-columns: 120px 2fr 1fr 1fr 0.8fr 1fr; padding: 14px 20px; align-items: center;
  border-bottom: 1px solid #eee; &:hover { background: #fafafa; }
  min-width: 760px;
`;

const ProductContainer = styled.div`
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 15px;
  background: #fafafa;
`;

const ProductCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  margin-bottom: 8px;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  background: ${({ selected }) =>
    selected ? "#000" : "#fff"};
  color: ${({ selected }) =>
    selected ? "#fff" : "#000"};
  border: 1px solid ${({ selected }) =>
    selected ? "#000" : "#eee"};
  transition: 0.2s;

  img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 6px;
  }

  h4 {
    margin: 0;
    font-size: 14px;
  }

  p {
    margin: 0;
    font-size: 12px;
    opacity: 0.7;
  }

  &:hover {
    transform: scale(1.01);
  }
`;

const CheckMark = styled.div`
  position: absolute;
  right: 12px;
  font-size: 18px;
  font-weight: bold;
`;

const BannerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 15px;
  margin-top: 10px;
  max-height: 350px;
  overflow-y: auto;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const BannerCard = styled.div`
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  border: 2px solid ${({ selected }) =>
    selected ? "#000" : "#eee"};
  transition: 0.2s;

  img {
    width: 100%;
    height: 120px;
    object-fit: cover;
  }

  .banner-title {
    padding: 8px;
    font-size: 13px;
    text-align: center;
  }

  &:hover {
    transform: scale(1.03);
  }
`;

const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  margin-top: 10px;
  max-height: 350px;
  overflow-y: auto;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const CategoryCard = styled.div`
  background: ${({ selected }) =>
    selected ? "#000" : "#fff"};
  color: ${({ selected }) =>
    selected ? "#fff" : "#000"};
  border: 1px solid ${({ selected }) =>
    selected ? "#000" : "#eee"};
  border-radius: 12px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  position: relative;
  transition: 0.2s;

  img {
    width: 100%;
    height: 90px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 8px;
  }

  h4 {
    font-size: 13px;
    margin: 0;
  }

  &:hover {
    transform: scale(1.03);
  }
`;
